import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-candidate',
  templateUrl: './error-candidate.component.html',
  styleUrls: ['./error-candidate.component.scss']
})
export class ErrorCandidateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
